import axios from 'axios'
import ObjToFormData from '@/assets/js/common/ObjToFormData'

export default {
  namespaced: true,

  state: {
    leagues: [],
    count: 0
  },

  getters: {
    all (state) {
      return state.leagues
    },

    count (state) {
      return state.count
    }
  },

  mutations: {
    SET_LEAGUES (state, leagues) {
      state.leagues = leagues
    },

    UPDATE_LEAGUE (state, league) {
      let index = state.leagues
        .findIndex((row) => { return row.id === league.id })
      if (index !== -1) {
        state.leagues[index] = league
      }
    },

    DELETE_LEAGUE (state, id) {
      let index = state.leagues
        .findIndex((row) => { return row.id === id })

      if (index !== -1) {
        state.leagues.splice(index, 1)
      }
    },

    SET_COUNT (state, count) {
      state.count = count
    }
  },

  actions: {
    async get ({ commit }, { params, status, game }) {
      let url = `/leagues/status/${status || 'all'}`

      if (game) {
        url += `/game/${game}`
      }

      let leagues = await axios.get(url, { params })
      commit('SET_LEAGUES', leagues.data)
    },

    async create ({ commit }, league) {
      return axios.post('/leagues', ObjToFormData(league))
    },

    async update ({ commit }, league) {
      let result = await axios.patch(`/leagues/${league.id}`, ObjToFormData(league))

      commit('UPDATE_LEAGUE', league)
      return result
    },

    async remove ({ commit }, id) {
      await axios.delete(`/leagues/${id}`)
      commit('DELETE_LEAGUE', id)
    },

    async getCount ({ commit }, { params, status, game }) {
      let url = `/leagues/count/status/${status || 'all'}`

      if (game) {
        url += `/game/${game}`
      }

      let count = await axios.get(url, { params })
      commit('SET_COUNT', count.data)
    }
  }
}
